export const DRIVER_LOAD_REQUEST = 'DRIVER_LOAD_REQUEST';
export const DRIVER_LOAD_SUCCESS = 'DRIVER_LOAD_SUCCESS';
export const DRIVER_LOAD_FAILURE = 'DRIVER_LOAD_FAILURE';
